import {
  FETCH_DS1_PRODUCT_VARIANT_OVERVIEW,
  RESET_DS1_PRODUCT_VARIANT_OVERVIEW,
} from "../../constants/action.constants";

const initialState = {
  data: null,
};

const ds1ProductVariantOverviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DS1_PRODUCT_VARIANT_OVERVIEW:
      return { data: action.payload };
    case RESET_DS1_PRODUCT_VARIANT_OVERVIEW:
      return initialState;
    default:
      return state;
  }
};

export default ds1ProductVariantOverviewReducer;
